import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import { loadCustomPaymentData } from "@Pages/BookForm/data/leadCustomPaymentData";
import { paymentStates } from "@Pages/Payment/constant";
import NotFound from "@Pages/NotFound";
import getQueryParams from "helpers/getQueryParams";
import isWeChatMiniProgramClient from "@Utils/isWeChatMiniProgramClient";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import useCustomPaymentPage from "./useCustomPaymentPage";

const CustomPaymentWrapper = loadable(() => import("./CustomPaymentWrapper"), {
  fallback: <FullPageLoader />,
});

const MiniProgramPaymentFailureLayout = loadable(
  () => import("../MiniProgramPaymentFailure/MiniProgramPaymentFailureLayout"),
  { fallback: <FullPageLoader /> },
);

export default (props: any): JSX.Element => {
  const { isError, isLoading } = useCustomPaymentPage();
  const dispatch = useDispatch();
  const queryParams = getQueryParams();
  const { token: urlToken } = useParams<{ token: string }>();
  const isMiniProgramFailure =
    queryParams?.payment_state === paymentStates.FAILED &&
    Boolean(urlToken) &&
    isWeChatMiniProgramClient();

  useEffect(() => {
    dispatch(loadCustomPaymentData(props));
  }, []);

  if (isMiniProgramFailure) {
    if (isError) {
      return <NotFound isStatus500 {...props} />;
    }

    if (isLoading) {
      return <FullPageLoader />;
    }

    return <MiniProgramPaymentFailureLayout />;
  }

  if (isError) {
    return <NotFound isStatus500 {...props} />;
  }

  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <ErrorBoundary>
      <CustomPaymentWrapper {...props} />
    </ErrorBoundary>
  );
};
